var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewable-list-item',[_c('my-device-item-content',{attrs:{"device":_vm.device}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }